// extracted by mini-css-extract-plugin
export default {"image":"template_image__Tv07s","textClass":"template_textClass__seULi","listClass":"template_listClass__AxdW7"};